import { IAppState } from '../../redux';
import { IRosreestrData } from '../../types/reducers/rosreestrData';

export const selectRosreestrData = (state: IAppState): IRosreestrData | null => {
  const { address, cardView } = state.rosreestrData;

  return address && cardView ? { address, cardView } : null;
};
